import React, { useState, useEffect } from 'react'
import { Classes, Dialog, Radio, RadioGroup } from '@blueprintjs/core'
import { Flex, Icon, Toaster } from '@ui'
import api from '@api'
import { groupBy } from 'lodash'
import { ISpaceType } from '@api'
import { ApolloError } from 'apollo-client'
import useFloor from '@providers/mapProvider/floorProvider/provider'
import css from './spaceType.module.scss'
import { Button } from '@runeffective/evo-design-system'

export interface SpaceTypesDialogProps {
  setisSpaceTypeOpen: (para: boolean) => void
  isSpaceTypeOpen: boolean
  selectedSpaces: string[]
  data: any
}

function getCount(spaceType: string, data: any[]) {
  const item = data?.find(({ key }) => spaceType === key)
  return item ? item.value : 0
}

export default function SpaceTypesDialog({
  setisSpaceTypeOpen,
  isSpaceTypeOpen,
  selectedSpaces,
  data,
}: SpaceTypesDialogProps) {
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState('')
  const [spaceTypesList, setspaceTypesList] = useState<ISpaceType[]>([])
  const floor = useFloor()
  useEffect(() => {
    api.company.spaceTypes().then((spaceType) => setspaceTypesList(spaceType))
  }, [])

  const grouped = groupBy(spaceTypesList, ({ interactivity }) =>
    interactivity === 'seatable' ? 'Personal' : 'Common'
  )

  function resetState() {
    setSelectedValue('')
    setBtnDisabled(true)
  }

  function onClickSubmit() {
    api.space
      .batchUpdateSpaceTypes(selectedSpaces, selectedValue)
      .then((usageTypes) => {
        Toaster.success({ message: 'Space Type updated successfully' })
        floor.reloadMap?.()
        setisSpaceTypeOpen(false)
      })
      .catch((error: ApolloError) => {
        Toaster.fail({ error })
      })
    resetState()
  }

  return (
    <>
      <Dialog
        style={{ paddingBottom: '0px' }}
        isOpen={isSpaceTypeOpen}
        className={css.dialogWidth}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
      >
        <div className={css.empList}>
          <Button
            style={{ position: 'absolute', top: '5px', right: '10px' }}
            aria-label="single icon button"
            onClick={() => {
              setisSpaceTypeOpen(false)
              resetState()
            }}
            size="default"
            layout="borderless"
          >
            <Icon name="close" />
          </Button>
          <div>
            <div className={css.dialogHeader}> Space Types </div>
          </div>
          <div className={css.labelText}>Update the selected spaces to the appropriate type</div>
          <div className={css.maxWidth}>
            <div className={css.checkboxLabel}>Personal</div>
            <div>
              {grouped.Personal?.map((item) => (
                <div className={css.checkboxPaddingTop} key={item.id}>
                  <RadioGroup
                    inline
                    onChange={(event) => {
                      const val = event.currentTarget.value
                      setSelectedValue(val)
                      setBtnDisabled(false)
                    }}
                    selectedValue={selectedValue}
                  >
                    <Radio
                      label={`${item.displayName} (${getCount(item.displayName, data)})`}
                      value={`${item.name}`}
                      style={{ marginBottom: '0px' }}
                    />
                  </RadioGroup>
                </div>
              ))}
            </div>
            <div className={css.checkboxLabel}>Common</div>
            <div>
              {grouped.Common?.map((item) => (
                <div className={css.checkboxPaddingTop} key={item.id}>
                  <RadioGroup
                    inline
                    onChange={(event) => {
                      const val = event.currentTarget.value
                      setSelectedValue(val)
                      setBtnDisabled(false)
                    }}
                    selectedValue={selectedValue}
                  >
                    <Radio
                      label={`${item.displayName} (${getCount(item.displayName, data)})`}
                      value={`${item.name}`}
                      style={{ marginBottom: '0px' }}
                    />
                  </RadioGroup>
                </div>
              ))}
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Flex style={{ gap: '8px' }} direction="row" justify="space-between">
                <Button
                  layout="borderless"
                  onClick={() => {
                    setisSpaceTypeOpen(false)
                    resetState()
                  }}
                  size="default"
                >
                  Cancel
                </Button>
                <Button
                  disabled={btnDisabled}
                  layout="primary"
                  onClick={() => onClickSubmit()}
                  size="default"
                >
                  Update
                </Button>
              </Flex>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}
